import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Twitter({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 17 13"
    >
      <Path
        d="M16.3301 1.52966C15.7334 1.82798 15.1368 1.92742 14.4407 2.02686C15.1368 1.6291 15.634 1.03247 15.8329 0.236963C15.2363 0.634717 14.5402 0.833594 13.7447 1.03247C13.148 0.43584 12.2531 0.0380859 11.3582 0.0380859C9.6677 0.0380859 8.17612 1.52966 8.17612 3.31956C8.17612 3.61787 8.17612 3.81675 8.27556 4.01562C5.59072 3.91619 3.10476 2.62349 1.51375 0.634717C1.21543 1.13191 1.11599 1.6291 1.11599 2.32517C1.11599 3.41899 1.71262 4.41338 2.60757 5.01001C2.11038 5.01001 1.61318 4.81113 1.11599 4.61226C1.11599 6.20327 2.20981 7.49597 3.70139 7.79429C3.40308 7.89373 3.10476 7.89373 2.80645 7.89373C2.60757 7.89373 2.40869 7.89373 2.20981 7.79429C2.60757 9.08699 3.80083 10.0814 5.29241 10.0814C4.19858 10.9763 2.80645 11.4735 1.21543 11.4735C0.917114 11.4735 0.718237 11.4735 0.419922 11.4735C1.9115 12.3685 3.60195 12.9651 5.39185 12.9651C11.3582 12.9651 14.6396 7.99316 14.6396 3.71731C14.6396 3.61787 14.6396 3.41899 14.6396 3.31956C15.3357 2.82236 15.9323 2.22573 16.3301 1.52966Z"
        fill={iconColor}
      />
    </Svg>
  );
}
